import React from "react";
import { FaArrowRight, FaQuoteLeft } from "react-icons/fa";
import "./Cli.css";
import Img1 from "../Assets/1111.jpg";
import Img2 from "../Assets/2222.jpg";
import Img3 from "../Assets/3333.jpg";
import Img4 from "../Assets/4444.jpg";
import Img5 from "../Assets/PastorJudith.jpg";
import Img6 from "../Assets/PastorA.jpeg";
import Footer from "./Footer";
import PdfViewer from "./PdfViewer";
import prospectusPdf from "../Assets/The City Leadership Institute Prospectus 2026 A4.pdf";

const APPLY_URL = "https://thecitychurchluzira.churchcenter.com/people/forms/936391";

const LEADERS = [
  { name: "Dr Alex Mutagubya", role: "Vision Bearer", img: Img6 },
  { name: "Miss Rebecca Baguma", role: "Principal, CLI", img: Img4 },
  { name: "Pastor Judith Icumar", role: "Leadership Mentor", img: Img5 },
];

const TESTIMONIALS = [
  { name: "Priscilla Maloba", quote: "CLI transformed my leadership journey, equipping me with the skills to serve my community.", img: Img3 },
  { name: "Julius Oboth", quote: "The teachings at CLI helped me become a more effective and faith-driven leader.", img: Img1 },
  { name: "Lydia Biira", quote: "CLI is more than an institute, it's a life-changing experience filled with wisdom and growth.", img: Img2 },
];

const Cli = () => (
  <>
    <header className="cli-hero">
      <div className="tcc-container cli-hero__inner">
        <p className="tcc-eyebrow cli-hero__eyebrow">Leadership development</p>
        <h1 className="cli-hero__title">The City Leadership Institute</h1>
        <p className="cli-hero__lead">
          Raising leaders to transform communities with faith, wisdom and impact.
        </p>
        <div className="cli-hero__actions">
          <a className="tcc-btn tcc-btn--accent tcc-btn--lg" href={APPLY_URL} target="_blank" rel="noopener noreferrer">
            Apply Now <FaArrowRight aria-hidden="true" />
          </a>
          <a className="tcc-btn tcc-btn--outline-on-dark tcc-btn--lg" href="#cli-prospectus">View Prospectus</a>
        </div>
      </div>
    </header>

    {/* About */}
    <section className="tcc-section cli-about" aria-labelledby="cli-about-h">
      <div className="tcc-container--narrow tcc-container cli-about__inner">
        <p className="tcc-eyebrow">About CLI</p>
        <h2 className="tcc-h2" id="cli-about-h">Equipping visionary leaders</h2>
        <p className="cli-about__text">
          At The City Leadership Institute, we foster a culture of open communication
          and collaboration, empowering leaders who can drive meaningful change in
          their communities. Whether your questions are about course structure,
          assignments or leadership principles, we are here to guide and support you
          every step of the way, building a strong network of visionary leaders
          equipped for the challenges of today and tomorrow.
        </p>
      </div>
    </section>

    {/* Prospectus */}
    <section id="cli-prospectus" className="tcc-section tcc-section--surface2 cli-prospectus" aria-labelledby="cli-pro-h" style={{ scrollMarginTop: "80px" }}>
      <div className="tcc-container">
        <div className="cli-head">
          <p className="tcc-eyebrow">Read the details</p>
          <h2 className="tcc-h2" id="cli-pro-h">The CLI prospectus</h2>
          <p className="tcc-lead">Everything you need to know about the 2026 programme.</p>
        </div>
        <div className="cli-prospectus__viewer tcc-card">
          <PdfViewer url={prospectusPdf} />
        </div>
      </div>
    </section>

    {/* Leadership */}
    <section className="tcc-section cli-team" aria-labelledby="cli-team-h">
      <div className="tcc-container">
        <div className="cli-head">
          <p className="tcc-eyebrow">Our people</p>
          <h2 className="tcc-h2" id="cli-team-h">Meet our leadership</h2>
        </div>
        <ul className="cli-team__grid">
          {LEADERS.map((l) => (
            <li className="cli-person tcc-card tcc-card--hover" key={l.name}>
              <div className="cli-person__media"><img src={l.img} alt={l.name} loading="lazy" /></div>
              <div className="cli-person__body">
                <h3 className="cli-person__name">{l.name}</h3>
                <p className="cli-person__role">{l.role}</p>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </section>

    {/* Testimonials */}
    <section className="tcc-section tcc-section--surface2 cli-testimonials" aria-labelledby="cli-test-h">
      <div className="tcc-container">
        <div className="cli-head">
          <p className="tcc-eyebrow">Alumni</p>
          <h2 className="tcc-h2" id="cli-test-h">What our alumni say</h2>
        </div>
        <ul className="cli-quotes">
          {TESTIMONIALS.map((t) => (
            <li className="cli-quote tcc-card" key={t.name}>
              <FaQuoteLeft aria-hidden="true" className="cli-quote__mark" />
              <p className="cli-quote__text">{t.quote}</p>
              <div className="cli-quote__person">
                <img src={t.img} alt={t.name} className="cli-quote__avatar" loading="lazy" />
                <span className="cli-quote__name">{t.name}</span>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </section>

    {/* CTA */}
    <section className="cli-cta" aria-labelledby="cli-cta-h">
      <div className="tcc-container cli-cta__inner">
        <h2 className="cli-cta__title" id="cli-cta-h">Join CLI today</h2>
        <p className="cli-cta__text">Become a transformational leader and make a difference in your community.</p>
        <a className="tcc-btn tcc-btn--on-dark tcc-btn--lg" href={APPLY_URL} target="_blank" rel="noopener noreferrer">
          Apply Now <FaArrowRight aria-hidden="true" />
        </a>
      </div>
    </section>

    <Footer />
  </>
);

export default Cli;
